import { Table } from 'semantic-ui-react';
import React from 'react';
import styled from 'styled-components';
import CellDiv from 'components/molecules/tables/components/CellDiv';

const TOTAL = 'TOTAL';
const NOT_APPLICABLE = '--';

const CellContainer = styled.div`
    display: flex;
    align-items: center;
    font-size: 13px;
    ${props => props.nowrap && 'white-space: nowrap;'}
`;

const Aggregate = ({ visibleColumns, flatRows }) => (
    <Table.Footer>
        <Table.Row>
            {
                visibleColumns.map((column) => {
                    let aggregateValue = NOT_APPLICABLE;

                    if (column.isIndexCol) {
                        aggregateValue = TOTAL;
                    } else if (column.smartAggregate) {
                        aggregateValue = column.smartAggregate(flatRows) || NOT_APPLICABLE;
                    }

                    return (
                        <Table.HeaderCell key={column.id}>
                            <CellContainer nowrap={column.nowrap}>
                                <CellDiv value={aggregateValue} type={column.type} strong/>
                            </CellContainer>
                        </Table.HeaderCell>
                    );
                })
            }
        </Table.Row>
    </Table.Footer>
);

export default Aggregate;



// WEBPACK FOOTER //
// ./src/components/atoms/tables/smarttables/tablePlugins/Aggregate.js